/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2022-10-04 10:55:08
 *
 *******************************************************/
// @flow

import React, { Component } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { Card, Tabs } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import ComingSoon from 'src/components/views/recommendation/manual-recommendation/management/coming-soon';
import HandPickedProductType from 'src/components/views/recommendation/manual-recommendation/management/manual-recommendation-type/hand-picked-product-type';
import SearchResult from 'src/components/views/recommendation/manual-recommendation/management/manual-recommendation-type/search-result';
import type { ManualRecommendationResponseType } from 'src/models/recommendation';
import {
  MANUAL_RECOMMENDATION_TABS,
  MANUAL_RECOMMENDATION_TAB_TYPE,
  MANUAL_RECOMMENDATION_TAB_ITEM
} from 'src/constants/recommendation';

type Props = {
  selectedTab: number,
  inputSearchText: string,
  manualHandPickedLoading: boolean,
  manualHandPickedLoadedSuccess: boolean,
  manualHandPickedRecommendations: ManualRecommendationResponseType[],
  manualSearching: boolean,
  manualSearchSuccess: boolean,
  manualRecommendationSearchResult: ManualRecommendationResponseType[],
  manualDeleting: boolean,
  manualDeleteSuccess: boolean,
  onDelete: (recommendationId: string) => void,
  onTabChange: (tabIndex: number) => void
};

type ComposedProps = Props & WithI18nProps;

type State = {};

class ManualRecommendationType extends Component<ComposedProps, State> {
  render() {
    const {
      i18n,
      inputSearchText,
      selectedTab,
      manualHandPickedLoading,
      manualHandPickedLoadedSuccess,
      manualHandPickedRecommendations,
      manualSearching,
      manualSearchSuccess,
      manualRecommendationSearchResult,
      manualDeleting,
      manualDeleteSuccess,
      onTabChange
    } = this.props;

    const tabs = MANUAL_RECOMMENDATION_TABS.map(item => ({
      ...item,
      content: i18n.translate(item.content)
    }));

    const tabComponents = [
      <HandPickedProductType
        loading={manualHandPickedLoading}
        loadedSuccess={manualHandPickedLoadedSuccess}
        manualRecommendations={manualHandPickedRecommendations}
        manualDeleting={manualDeleting}
        manualDeleteSuccess={manualDeleteSuccess}
        onDelete={this.handleDeleteRecommendation}
      />,
      <ComingSoon />,
      <ComingSoon />
    ];

    if (!_.isEmpty(inputSearchText)) {
      const searchTab =
        MANUAL_RECOMMENDATION_TAB_ITEM[MANUAL_RECOMMENDATION_TAB_TYPE.SEARCH_RESULT];

      tabs.unshift({
        ...searchTab,
        content: i18n.translate(searchTab.content)
      });

      tabComponents.unshift(
        <SearchResult
          searching={manualSearching}
          searchSuccess={manualSearchSuccess}
          manualRecommendations={manualRecommendationSearchResult}
          manualDeleting={manualDeleting}
          manualDeleteSuccess={manualDeleteSuccess}
          onDelete={this.handleDeleteRecommendation}
        />
      );
    }

    return (
      <div className="tabs">
        <Tabs tabs={tabs} selected={selectedTab} onSelect={onTabChange}>
          <Card.Section>{tabComponents[selectedTab]}</Card.Section>
        </Tabs>
      </div>
    );
  }

  handleDeleteRecommendation = recommendationId => {
    const { onDelete } = this.props;
    onDelete(recommendationId);
  };
}

const mapStateToProps = (state, props) => {
  // Get manual recommendations
  const manualHandPickedRecommendations = _.get(
    state.recommendation,
    'manualHandPickedRecommendations',
    []
  );
  const manualHandPickedLoading = _.get(state.recommendation, 'manualHandPickedLoading', false);
  const manualHandPickedLoadedSuccess = _.get(
    state.recommendation,
    'manualHandPickedLoadedSuccess',
    false
  );

  // Get manual recommendations search result
  const manualSearching = _.get(state.recommendation, 'manualSearching', false);
  const manualSearchSuccess = _.get(state.recommendation, 'manualSearchSuccess', false);
  const manualRecommendationSearchResult = _.get(
    state.recommendation,
    'manualRecommendationSearchResult',
    []
  );

  const manualDeleting = _.get(state.recommendation, 'manualDeleting', false);
  const manualDeleteSuccess = _.get(state.recommendation, 'manualDeleteSuccess', false);
  return {
    manualHandPickedRecommendations,
    manualHandPickedLoading,
    manualHandPickedLoadedSuccess,
    manualSearching,
    manualRecommendationSearchResult,
    manualSearchSuccess,
    manualDeleting,
    manualDeleteSuccess
  };
};

export default withI18n()(connect(mapStateToProps)(ManualRecommendationType));
